module.exports = __webpack_public_path__ + "static/media/video-crisis-situation-en.58e88982.vtt";